import moment from 'moment';
import validator from 'validator';

const months = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'aout',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
];

export const isEmail = email => validator.isEmail(email || "");

export const isDomain = domain => {
  const rule = /^[^\s.]{1,64}\.[^\s.]{1,64}$/;
  return domain.match(rule);
};

export const isPhone = ph => {
  return true;
};

export const hasFrenchPhoneLeadingZero = (phone) => {
  const normalizedPhone = (phone || '').replace(/[\s()-]/g, '');
  return normalizedPhone.startsWith('+330');
};

export const getFrenchPhoneDigits = (phone) => {
  const digits = String(phone || '').replace(/\D/g, '');
  if (digits.startsWith('33')) return digits;
  if (digits.startsWith('0')) return `33${digits.slice(1)}`;
  return digits;
};

export const isValidFrenchPhoneNumber = (phone) => {
  if (!phone || !String(phone).trim()) return false;
  if (hasFrenchPhoneLeadingZero(phone)) return false;

  const digits = String(phone).replace(/\D/g, '');
  if (!digits) return false;

  if (digits.startsWith('33') || digits.startsWith('0')) {
    const frenchDigits = getFrenchPhoneDigits(phone);
    return /^33[1-9]\d{8}$/.test(frenchDigits);
  }

  return digits.length >= 10;
};

export const hasInvalidPhoneFormat = (phone) => {
  if (!phone || !String(phone).trim()) return false;
  if (hasFrenchPhoneLeadingZero(phone)) return false;
  return !isValidFrenchPhoneNumber(phone);
};

export const hasPhoneValidationError = (phone) => {
  if (!phone || !String(phone).trim()) return false;
  return hasFrenchPhoneLeadingZero(phone) || hasInvalidPhoneFormat(phone);
};

export const PHONE_VALIDATION_MESSAGE_IDS = {
  leadingZero: 'validation.phone.leading_zero',
  invalidFormat: 'validation.phone.invalid_format',
  invalid: 'validation.phone.invalid',
};

const PHONE_VALIDATION_MESSAGE_DEFAULTS = {
  leadingZero: 'Votre numéro ne semble pas correct',
  invalidFormat: 'Le format du téléphone n\'est pas correct',
  invalid: 'Le numéro de téléphone est invalide',
};

const translatePhoneMessage = (formatMessage, key) => {
  if (formatMessage) {
    return formatMessage({
      id: PHONE_VALIDATION_MESSAGE_IDS[key],
      defaultMessage: PHONE_VALIDATION_MESSAGE_DEFAULTS[key],
    });
  }
  return PHONE_VALIDATION_MESSAGE_DEFAULTS[key];
};

export const appendPhoneValidationErrors = (errors, phone, field = 'phone', formatMessage) => {
  if (!phone?.trim() || !hasPhoneValidationError(phone)) return errors || {};
  const next = { ...(errors || {}) };
  if (!next[field]) {
    next[field] = [getPhoneValidationHelperText(phone, { formatMessage })];
  }
  return next;
};

export const getPhoneValidationHelperText = (phone, { emptyText, invalidText, formatMessage } = {}) => {
  if (!phone) return emptyText || '';
  if (hasFrenchPhoneLeadingZero(phone)) return translatePhoneMessage(formatMessage, 'leadingZero');
  if (hasInvalidPhoneFormat(phone)) return translatePhoneMessage(formatMessage, 'invalidFormat');
  return invalidText || translatePhoneMessage(formatMessage, 'invalid');
};

export const getDateString = str => {
  if (str === '') {
    return '';
  }
  const date = new Date(str);
  const ddd = date.getDate();
  return `${ddd} ${months[date.getMonth()]} ${date.getFullYear()}`;
};

export const getHHMMDDMMYYYYFromTimeStamp = str => {
  return moment(str).format("HH:mm DD/MM/YYYY");
};

export const get10LastLetters = str => String(str).slice(-10);

export const includes = (str1, str2) =>
  String(str1).toLowerCase().includes(String(str2).toLowerCase());

export const getListFromTreeString = str => {
  const treeData = JSON.parse(str);
  const result = [];
  while (true) {
    const first = treeData[0];
    treeData.shift();
    result.push(first.title);
    if (first.children) {
      for (let index = first.children.length - 1; index >= 0; index -= 1) {
        treeData.unshift(first.children[index]);
      }
    }
    if (treeData.length === 0) {
      break;
    }
  }

  return result;
};

export const includesCapitalLetter = str => {
  return /[A-Z]/.test(str);
};

export const includesNumber = str => {
  return /\d/.test(str);
};

export const isCorrectFileName = fileName => {
  const reg = new RegExp('^[-A-Za-z0-9_.~ ]+$');
  return reg.test(fileName);
};

export const getPasswordSecureWarning = password => {
  if (!password || password.length < 8) {
    return 'Password must be at least 8 characters';
  }
  const matchedCase = new Array();
  matchedCase.push('[!@#$%^&*;]'); // Special Charector
  matchedCase.push('[A-Z]'); // Uppercase Alpabates
  matchedCase.push('[0-9]'); // Numbers
  matchedCase.push('[a-z]'); // Lowercase Alphabates

  const messages = [
    'Password must include at least one special character (! , @, #, ...)',
    'Password must include at least one uppercase letter',
    'Password must include at least one number',
    'Password must include at least one lowercase letter'
  ];

  for (let i = 0; i < matchedCase.length; i++) {
    if (!new RegExp(matchedCase[i]).test(password)) {
      return messages[i];
    }
  }
  return null;
};
export const validURL = str => {
  const regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#:.?+=&%!\-/]))?/;
  if (!regex.test(str)) {
    return false;
  } else {
    return true;
  }
}